import React from 'react';
import useBackwardNavigationStore from '../../stores/useBackwardNavigationStore';
import { useStepNavigation } from '../../hooks/useStepNavigation';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/dialog';

/** Confirm dialog for backward step navigation (shared across StepHeader / StepFooter). */
export default function BackwardNavDialog() {
  const pending = useBackwardNavigationStore((state) => state.pending);
  const { confirmBackwardNavigation, cancelBackwardNavigation } = useStepNavigation();

  return (
    <AlertDialog
      open={!!pending}
      onOpenChange={(open) => {
        if (!open) cancelBackwardNavigation();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Discard step changes?</AlertDialogTitle>
          <AlertDialogDescription>{pending?.message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Stay on this step</AlertDialogCancel>
          <AlertDialogAction onClick={confirmBackwardNavigation}>
            Discard and go back
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
